var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "51px",
    viewBox: "0 0 64 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PracticeID Logo - Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PracticeID-Logo---Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web_asset_FILL0_wght400_GRAD0_opsz24",
    fill: "#1A73E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4,50.8717949 C4.64,50.8717949 3.13333333,50.2491453 1.88,49.0038462 C0.626666667,47.758547 0,46.2615385 0,44.5128205 L0,6.35897436 C0,4.61025641 0.626666667,3.11324786 1.88,1.86794872 C3.13333333,0.622649573 4.64,0 6.4,0 L57.6,0 C59.36,0 60.8666667,0.622649573 62.12,1.86794872 C63.3733333,3.11324786 64,4.61025641 64,6.35897436 L64,44.5128205 C64,46.2615385 63.3733333,47.758547 62.12,49.0038462 C60.8666667,50.2491453 59.36,50.8717949 57.6,50.8717949 L6.4,50.8717949 Z M6.4,44.5128205 L57.6,44.5128205 L57.6,12.7179487 L6.4,12.7179487 L6.4,44.5128205 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(42.000000, 5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625,3.25 C12.0763889,3.25 12.4600694,3.09201389 12.7760417,2.77604167 C13.0920139,2.46006944 13.25,2.07638889 13.25,1.625 C13.25,1.17361111 13.0920139,0.789930556 12.7760417,0.473958333 C12.4600694,0.157986111 12.0763889,0 11.625,0 C11.1736111,0 10.7899306,0.157986111 10.4739583,0.473958333 C10.1579861,0.789930556 10,1.17361111 10,1.625 C10,2.07638889 10.1579861,2.46006944 10.4739583,2.77604167 C10.7899306,3.09201389 11.1736111,3.25 11.625,3.25 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.625,3.25 C7.07638889,3.25 7.46006944,3.09201389 7.77604167,2.77604167 C8.09201389,2.46006944 8.25,2.07638889 8.25,1.625 C8.25,1.17361111 8.09201389,0.789930556 7.77604167,0.473958333 C7.46006944,0.157986111 7.07638889,0 6.625,0 C6.17361111,0 5.78993056,0.157986111 5.47395833,0.473958333 C5.15798611,0.789930556 5,1.17361111 5,1.625 C5,2.07638889 5.15798611,2.46006944 5.47395833,2.77604167 C5.78993056,3.09201389 6.17361111,3.25 6.625,3.25 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625,3.25 C2.07638889,3.25 2.46006944,3.09201389 2.77604167,2.77604167 C3.09201389,2.46006944 3.25,2.07638889 3.25,1.625 C3.25,1.17361111 3.09201389,0.789930556 2.77604167,0.473958333 C2.46006944,0.157986111 2.07638889,0 1.625,0 C1.17361111,0 0.789930556,0.157986111 0.473958333,0.473958333 C0.157986111,0.789930556 0,1.17361111 0,1.625 C0,2.07638889 0.157986111,2.46006944 0.473958333,2.77604167 C0.789930556,3.09201389 1.17361111,3.25 1.625,3.25 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(42.800000, 28.600000) scale(-1, 1) translate(-42.800000, -28.600000) translate(33.200000, 19.000000)",
    fill: "#1A73E8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,19.2 L19.2,19.2 L19.2,17.76 C19.2,16.8533333 18.9466667,16.0133333 18.44,15.24 C17.9333333,14.4666667 17.2266667,13.8666667 16.32,13.44 C15.2533333,12.96 14.1733333,12.6 13.08,12.36 C11.9866667,12.12 10.8266667,12 9.6,12 C8.37333333,12 7.21333333,12.12 6.12,12.36 C5.02666667,12.6 3.94666667,12.96 2.88,13.44 C1.97333333,13.8666667 1.26666667,14.4666667 0.76,15.24 C0.253333333,16.0133333 0,16.8533333 0,17.76 L0,19.2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,9.6 C10.9333333,9.6 12.0666667,9.13333333 13,8.2 C13.9333333,7.26666667 14.4,6.13333333 14.4,4.8 C14.4,3.46666667 13.9333333,2.33333333 13,1.4 C12.0666667,0.466666667 10.9333333,0 9.6,0 C8.26666667,0 7.13333333,0.466666667 6.2,1.4 C5.26666667,2.33333333 4.8,3.46666667 4.8,4.8 C4.8,6.13333333 5.26666667,7.26666667 6.2,8.2 C7.13333333,9.13333333 8.26666667,9.6 9.6,9.6 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1A73E8",
    points: "11 25.8 30.2 25.8 30.2 21 11 21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1A73E8",
    points: "11 35.4 23.8 35.4 23.8 30.6 11 30.6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7cf243b6f4938306ca92096108bac01.svg";
export { ForwardRef as ReactComponent };